import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { FeatureViewed } from '@repo/segment/components/FeatureViewed';
import { PostAuthor } from '@repo/supergraph/structuredContent/hydration/FirstPersonPerspectiveItem/schema';
import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import Image from 'next/image';
import { StructuredContentRenderer } from '../..';

type PerspectiveItemProps = StructuredContentDocument<{
  authorId: string;
  children: StructuredContentDocument;
  author: PostAuthor;
}>;

export function FirstPersonPerspectiveItem({ props }: PerspectiveItemProps) {
  const { children, author } = props;
  const authorMedia = author.featuredMedia;

  return (
    <FeatureViewed entitySection="banking" entityName="first-person-perspective-item">
      <Box
        sx={{
          width: '100%',
          bgcolor: 'greens.light',
          borderRadius: 2,
          height: '100%',
        }}
      >
        <Grid
          container
          sx={{
            paddingX: 4,
            paddingY: 3,
            justifyContent: { sm: 'center' },
            rowGap: 3,
            columnGap: { sm: 3, md: 0 },
          }}
        >
          <Grid size={{ xs: 12, sm: 9, md: 10 }} sx={{ paddingRight: 3 }}>
            <Box
              sx={{
                paddingLeft: 3,
                borderLeftWidth: 4,
                borderLeftColor: 'greens.lighter',
                borderLeftStyle: 'solid',
              }}
            >
              <StructuredContentRenderer doc={children} />
            </Box>
          </Grid>
          <Grid
            size={{ sm: 2 }}
            sx={{
              display: 'flex',
              flexDirection: { sm: 'column' },
              alignItems: { xs: 'flex-start', sm: 'center' },
              gap: 2,
            }}
          >
            {authorMedia && authorMedia.croppedImage && (
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: { xs: '60px', sm: '111px' },
                  height: { xs: '60px', sm: '111px' },
                }}
              >
                <Image
                  alt={`${author.fullName}'s profile picture`}
                  src={authorMedia?.croppedImage?.sourceUrl}
                  fill
                  style={{ objectFit: 'cover' }}
                />
              </Box>
            )}
            <Typography variant="bodySmall">{author.fullName}</Typography>
          </Grid>
        </Grid>
      </Box>
    </FeatureViewed>
  );
}
